module.exports = __webpack_public_path__ + "static/media/arrow.f0f73c5f.svg";